import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * ScrollToTop component - Scrolls window to top on route changes
 * This component should be placed inside the Router but doesn't render anything
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever the pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
